import React from 'react'
import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip'

interface PropsType extends TooltipProps {
	className?: string
}

const ChildrenComponent = React.forwardRef(function MyComponent(
	props: { children: any },
	ref: any,
) {
	return (
		<div {...props} ref={ref}>
			{props.children}
		</div>
	)
})

export const Tooltip = (props: PropsType) => {
	return (
		<MuiTooltip {...props} arrow>
			<ChildrenComponent ref={props.ref}>{props.children}</ChildrenComponent>
		</MuiTooltip>
	)
}
